import { Solution } from "@/types/solutions";

// Sample data for the solutions
export const solutionsData: Solution[] = [
  // Julia De Rosi GSA solutions from the image
  {
    id: "gsa-j1",
    title: "Federal Building Sustainable Construction Framework",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Sustainability",
    basePrice: 8750,
    price: 8750,
    description: "Comprehensive framework for implementing sustainable construction practices in federal buildings.",
    capturedDate: "2024-03-20",
    contentType: "Private"
  },
  {
    id: "gsa-j2",
    title: "GSA Public Building Service Modern Workplace Strategy",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Workplace Design",
    basePrice: 6250,
    price: 6250,
    description: "Strategic approach to designing and implementing modern workplace environments for federal agencies.",
    capturedDate: "2024-02-15",
    contentType: "Private"
  },
  {
    id: "gsa-j3",
    title: "Federal Historic Property Adaptive Reuse Model",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Historic Preservation",
    basePrice: 7500,
    price: 7500,
    description: "Model for adapting and repurposing historic federal properties while preserving their cultural significance.",
    capturedDate: "2024-01-25",
    contentType: "Public"
  },
  // Heather Edwards solutions
  {
    id: "gsa-he1",
    title: "Federal Acquisition Streamlining Framework",
    agency: "GSA",
    curator: "Heather Edwards",
    commercialType: "Sale",
    category: "Procurement",
    basePrice: 2500,
    price: 2500,
    description: "Specialized knowledge base on navigating federal procurement regulations and optimizing acquisition processes.",
    capturedDate: "2024-03-15",
    contentType: "Private"
  },
  {
    id: "gsa-he2",
    title: "Federal Workforce Management Strategies",
    agency: "GSA",
    curator: "Heather Edwards",
    commercialType: "Sale",
    category: "Human Resources",
    basePrice: 4200,
    price: 4200,
    description: "Strategic frameworks for managing federal workforce transitions and organizational change.",
    capturedDate: "2024-03-10",
    contentType: "Private"
  },
  {
    id: "gsa-he3",
    title: "GSA Leadership Development Programs",
    agency: "GSA",
    curator: "Heather Edwards",
    commercialType: "Sale",
    category: "Leadership",
    basePrice: 3800,
    price: 3800,
    description: "Comprehensive leadership development programs tailored for federal agency executives.",
    capturedDate: "2024-03-05",
    contentType: "Public"
  },
  // Charles Hardy solutions
  {
    id: "gsa-ch1",
    title: "Federal Building System Architecture Standards",
    agency: "GSA",
    curator: "Charles Hardy",
    commercialType: "Sale",
    category: "Architecture",
    basePrice: 9200,
    price: 9200,
    description: "Comprehensive architectural standards and guidelines for federal building system design and implementation.",
    capturedDate: "2024-03-12",
    contentType: "Private"
  },
  {
    id: "gsa-ch2",
    title: "Infrastructure Modernization Blueprint",
    agency: "GSA",
    curator: "Charles Hardy",
    commercialType: "Sale",
    category: "Infrastructure",
    basePrice: 8750,
    price: 8750,
    description: "Strategic blueprint for modernizing federal infrastructure systems and technology platforms.",
    capturedDate: "2024-03-08",
    contentType: "Private"
  },
  {
    id: "gsa-ch3",
    title: "Federal Data Center Consolidation Framework",
    agency: "GSA",
    curator: "Charles Hardy",
    commercialType: "Sale",
    category: "IT Architecture",
    basePrice: 7500,
    price: 7500,
    description: "Framework for consolidating and optimizing federal data center operations and architecture.",
    capturedDate: "2024-03-01",
    contentType: "Public"
  },
  // Original sample data
  {
    id: "gsa-001",
    title: "Federal Contract Negotiation Best Practices",
    agency: "GSA",
    curator: "Karen Watson",
    commercialType: "Sale",
    category: "Procurement",
    basePrice: 2500,
    price: 2500,
    description: "Specialized knowledge base on navigating federal procurement regulations and optimizing acquisition processes.",
    contentType: "Private"
  },
  {
    id: "gsa-002",
    title: "Government Property Management System",
    agency: "GSA",
    curator: "Trey Fleming",
    commercialType: "Lease",
    category: "Asset Management",
    basePrice: 18000,
    price: 1800,
    description: "Comprehensive system for tracking and managing government property assets across agencies.",
    contentType: "Private"
  },
  {
    id: "gsa-003",
    title: "Federal Building Sustainability Guide",
    agency: "GSA",
    curator: "Morgan Eldred, PhD",
    commercialType: "Collaborate",
    category: "Sustainability",
    basePrice: 4750,
    price: 950,
    description: "Knowledge base for implementing green building practices in federal facilities.",
    contentType: "Public"
  },
  {
    id: "ed-001",
    title: "Title I Program Implementation Framework",
    agency: "Education",
    curator: "Mike Mosher",
    commercialType: "Sale",
    category: "K-12 Education",
    basePrice: 3200,
    price: 3200,
    description: "Expert guidance on implementing and managing Title I programs for disadvantaged students.",
    contentType: "Private"
  },
  {
    id: "ed-002",
    title: "Federal Student Aid Processing System",
    agency: "Education",
    curator: "Jess Simm",
    commercialType: "Lease",
    category: "Higher Education",
    basePrice: 11250,
    price: 4500,
    description: "Specialized knowledge on federal student aid processing and compliance requirements.",
    contentType: "Private"
  },
  {
    id: "noaa-001",
    title: "Advanced Weather Prediction Models",
    agency: "NOAA",
    curator: "Jim Lawnin",
    commercialType: "Stake",
    category: "Weather Services",
    basePrice: 15600,
    price: 7800,
    description: "Sophisticated weather prediction models developed by NOAA scientists.",
    contentType: "Private"
  },
  {
    id: "noaa-002",
    title: "Coastal Erosion Mitigation Framework",
    agency: "NOAA",
    curator: "Karen Watson",
    commercialType: "Collaborate",
    category: "Coastal Management",
    basePrice: 14500,
    price: 2900,
    description: "Expert knowledge base on managing and mitigating coastal erosion issues.",
    contentType: "Public"
  },
  // Adding more items to demonstrate the concept
  // GSA items
  {
    id: "gsa-004",
    title: "Federal Fleet Management System",
    agency: "GSA",
    curator: "Karen Watson",
    commercialType: "Sale",
    category: "Fleet Management",
    basePrice: 3200,
    price: 3200,
    description: "Comprehensive system for federal vehicle fleet management and optimization.",
    contentType: "Private"
  },
  {
    id: "gsa-005",
    title: "Government Technology Procurement Guide",
    agency: "GSA",
    curator: "Trey Fleming",
    commercialType: "Lease",
    category: "Technology",
    basePrice: 19500,
    price: 1950,
    description: "Expert guidance on procuring and implementing technology solutions in government contexts.",
    contentType: "Private"
  },
  // Education items
  {
    id: "ed-003",
    title: "Educational Assessment Framework",
    agency: "Education",
    curator: "Mike Mosher",
    commercialType: "Sale",
    category: "Assessment",
    basePrice: 2700,
    price: 2700,
    description: "Specialized knowledge base for developing and implementing educational assessments.",
    contentType: "Private"
  },
  {
    id: "ed-004",
    title: "Special Education Compliance System",
    agency: "Education",
    curator: "Jess Simm",
    commercialType: "Collaborate",
    category: "Special Education",
    basePrice: 19000,
    price: 3800,
    description: "Comprehensive knowledge base on special education regulations and compliance.",
    contentType: "Public"
  },
  // NOAA items
  {
    id: "noaa-003",
    title: "Marine Ecosystem Monitoring Framework",
    agency: "NOAA",
    curator: "Jim Lawnin",
    commercialType: "Stake",
    category: "Ocean Science",
    basePrice: 11200,
    price: 5600,
    description: "Advanced system for monitoring and analyzing marine ecosystem health.",
    contentType: "Public"
  },
  {
    id: "noaa-004",
    title: "Climate Data Analysis Tools",
    agency: "NOAA",
    curator: "Karen Watson",
    commercialType: "Sale",
    category: "Climate Science",
    basePrice: 4200,
    price: 4200,
    description: "Specialized tools for analyzing and interpreting climate data sets.",
    contentType: "Public"
  },
  // Requirements Generation Knowledge Bases
  {
    id: "gsa-rg1",
    title: "GSA Space Planning Standards",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Requirements Generation",
    basePrice: 7000,
    price: 7000,
    description: "Comprehensive guidelines for federal building space requirements and floor plan optimization.",
    capturedDate: "2024-01-15",
    contentType: "Private"
  },
  {
    id: "gsa-rg2",
    title: "Automated Floor Plan Generation Framework",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Requirements Generation",
    basePrice: 8000,
    price: 8000,
    description: "AI-driven tools for generating efficient floor plans based on occupancy requirements.",
    capturedDate: "2024-02-20",
    contentType: "Private"
  },
  {
    id: "gsa-rg3",
    title: "Space Requirements Calculator",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Requirements Generation",
    basePrice: 5500,
    price: 5500,
    description: "Interactive tool for calculating optimal space allocation based on federal workforce projections.",
    capturedDate: "2024-01-30",
    contentType: "Public"
  },
  {
    id: "gsa-rg4",
    title: "Federal Building Code Compliance Guide",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Requirements Generation",
    basePrice: 6500,
    price: 6500,
    description: "Requirements and standards for ensuring floor plans meet federal building codes.",
    capturedDate: "2024-02-10",
    contentType: "Public"
  },
  {
    id: "gsa-rg5",
    title: "Occupancy Planning Best Practices",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Requirements Generation",
    basePrice: 6000,
    price: 6000,
    description: "Evidence-based approaches to space planning for federal facilities.",
    capturedDate: "2024-01-25",
    contentType: "Private"
  },
  // Space Furniture Layout Knowledge Bases
  {
    id: "gsa-sfl1",
    title: "Workplace Modeling: Optimal Workspace Configurations",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Space Furniture Layout",
    basePrice: 7500,
    price: 7500,
    description: "Advanced modeling techniques for creating optimal workspace configurations based on federal requirements.",
    capturedDate: "2024-01-18",
    contentType: "Private"
  },
  {
    id: "gsa-sfl2",
    title: "Scenario Testing: Open Office vs Hybrid Strategies",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Space Furniture Layout",
    basePrice: 6750,
    price: 6750,
    description: "Comparative analysis tools for testing different office layout strategies and their effectiveness.",
    capturedDate: "2024-02-22",
    contentType: "Private"
  },
  {
    id: "gsa-sfl3",
    title: "Automated Space Planning: GSA Standards Implementation",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Space Furniture Layout",
    basePrice: 8000,
    price: 8000,
    description: "Automated tools for space planning that comply with GSA standards and regulations.",
    capturedDate: "2024-01-28",
    contentType: "Private"
  },
  {
    id: "gsa-sfl4",
    title: "Generative Furniture Design: Modular & Ergonomic Solutions",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Space Furniture Layout",
    basePrice: 8750,
    price: 8750,
    description: "AI-powered furniture design tools for creating modular and ergonomic workspace solutions.",
    capturedDate: "2024-02-15",
    contentType: "Private"
  },
  {
    id: "gsa-sfl5",
    title: "Furniture Reconfiguration & Re-use Guidelines",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Space Furniture Layout",
    basePrice: 6250,
    price: 6250,
    description: "Guidelines and best practices for reconfiguring and reusing existing furniture in federal facilities.",
    capturedDate: "2024-01-20",
    contentType: "Public"
  },
  // Analysis Tools Knowledge Bases
  {
    id: "gsa-at1",
    title: "Zoning & Code Compliance: Automated Checks",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 7750,
    price: 7750,
    description: "Automated systems for checking zoning compliance and building codes in federal construction projects.",
    capturedDate: "2024-01-22",
    contentType: "Private"
  },
  {
    id: "gsa-at2",
    title: "Space Utilization & Circulation Analysis",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 7250,
    price: 7250,
    description: "Advanced analytics for optimizing space utilization and traffic flow patterns in federal buildings.",
    capturedDate: "2024-02-18",
    contentType: "Private"
  },
  {
    id: "gsa-at3",
    title: "Daylighting Analysis: Optimization Framework",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 6500,
    price: 6500,
    description: "Framework for analyzing and optimizing natural lighting in federal building designs.",
    capturedDate: "2024-01-30",
    contentType: "Public"
  },
  {
    id: "gsa-at4",
    title: "View Analysis: Building Orientation & Window Placement",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 6000,
    price: 6000,
    description: "Tools for analyzing views and optimizing building orientation and window placement strategies.",
    capturedDate: "2024-02-12",
    contentType: "Public"
  },
  {
    id: "gsa-at5",
    title: "Acoustic Analysis: HVAC & Partition Construction",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 7000,
    price: 7000,
    description: "Comprehensive acoustic analysis tools for HVAC systems and partition construction in federal facilities.",
    capturedDate: "2024-01-25",
    contentType: "Private"
  },
  {
    id: "gsa-at6",
    title: "Automated Plan Checking: GSA Standards Compliance",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 8250,
    price: 8250,
    description: "Automated plan checking systems ensuring compliance with GSA building standards and regulations.",
    capturedDate: "2024-02-20",
    contentType: "Private"
  },
  {
    id: "gsa-at7",
    title: "Clash Detection & Conflict Resolution",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 7500,
    price: 7500,
    description: "Advanced clash detection and conflict resolution tools for federal building design coordination.",
    capturedDate: "2024-02-08",
    contentType: "Private"
  },
  {
    id: "gsa-at8",
    title: "Predictive Issue Detection: Cost Overrun Prevention",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 8500,
    price: 8500,
    description: "Predictive analytics for detecting potential issues and preventing cost overruns in federal projects.",
    capturedDate: "2024-01-28",
    contentType: "Private"
  },
  {
    id: "gsa-at9",
    title: "Smart Building Management: HVAC & Lighting Optimization",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Analysis Tools",
    basePrice: 8000,
    price: 8000,
    description: "Smart building management systems for optimizing HVAC and lighting performance in federal facilities.",
    capturedDate: "2024-02-15",
    contentType: "Private"
  },
  // Cost and Schedule Estimation Knowledge Bases
  {
    id: "gsa-cse1",
    title: "Material & Cost Optimization: Contract Specifications",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Cost Schedule Estimation",
    basePrice: 9000,
    price: 9000,
    description: "Advanced tools for optimizing material costs and developing comprehensive contract specifications for federal projects.",
    capturedDate: "2024-01-20",
    contentType: "Private"
  },
  {
    id: "gsa-cse2",
    title: "Procurement & Bid Support: Vendor Analysis",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Cost Schedule Estimation",
    basePrice: 7750,
    price: 7750,
    description: "Comprehensive vendor analysis and bid support systems for federal procurement processes.",
    capturedDate: "2024-02-16",
    contentType: "Private"
  },
  {
    id: "gsa-cse3",
    title: "Schedule Scenarios: Resource Loaded Planning",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Cost Schedule Estimation",
    basePrice: 7250,
    price: 7250,
    description: "Resource-loaded planning tools for developing and analyzing multiple schedule scenarios in federal projects.",
    capturedDate: "2024-01-28",
    contentType: "Private"
  },
  {
    id: "gsa-cse4",
    title: "Rough Order of Magnitude Costing",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Cost Schedule Estimation",
    basePrice: 6750,
    price: 6750,
    description: "ROM costing frameworks and methodologies for early-stage federal project cost estimation.",
    capturedDate: "2024-02-12",
    contentType: "Public"
  },
  {
    id: "gsa-cse5",
    title: "Phased Project Execution Timeline",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Cost Schedule Estimation",
    basePrice: 7000,
    price: 7000,
    description: "Comprehensive frameworks for developing phased project execution timelines for complex federal construction projects.",
    capturedDate: "2024-01-25",
    contentType: "Private"
  },
  // Visualization & Rendering Knowledge Bases
  {
    id: "gsa-vr1",
    title: "3D Modeling & Visualization: Realistic Virtual Models",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Visualization Rendering",
    basePrice: 9500,
    price: 9500,
    description: "Advanced 3D modeling and visualization tools for creating realistic virtual models of federal building projects.",
    capturedDate: "2024-01-24",
    contentType: "Private"
  },
  {
    id: "gsa-vr2",
    title: "Style Transfer & Concept Art: Space Visualization",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Visualization Rendering",
    basePrice: 8250,
    price: 8250,
    description: "AI-powered style transfer and concept art tools for visualizing federal space designs and concepts.",
    capturedDate: "2024-02-14",
    contentType: "Private"
  },
  {
    id: "gsa-vr3",
    title: "Furniture & Space Layout Rendering",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Visualization Rendering",
    basePrice: 7500,
    price: 7500,
    description: "Specialized rendering tools for furniture placement and space layout visualization in federal facilities.",
    capturedDate: "2024-01-30",
    contentType: "Public"
  },
  {
    id: "gsa-vr4",
    title: "Concept Renderings & Mood Boards",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Visualization Rendering",
    basePrice: 6500,
    price: 6500,
    description: "Tools and frameworks for creating concept renderings and mood boards for federal building design projects.",
    capturedDate: "2024-02-08",
    contentType: "Public"
  },
  // Post-Occupancy Monitoring Knowledge Bases
  {
    id: "gsa-pom1",
    title: "Employee Experience & Feedback Integration",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Post Occupancy Monitoring",
    basePrice: 7250,
    price: 7250,
    description: "Comprehensive systems for collecting and integrating employee experience feedback in federal workplace environments.",
    capturedDate: "2024-01-26",
    contentType: "Private"
  },
  {
    id: "gsa-pom2",
    title: "Predictive Maintenance: Building Systems Monitoring",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Post Occupancy Monitoring",
    basePrice: 8750,
    price: 8750,
    description: "Predictive maintenance frameworks for monitoring and maintaining federal building systems and infrastructure.",
    capturedDate: "2024-02-18",
    contentType: "Private"
  },
  {
    id: "gsa-pom3",
    title: "Building System Monitoring: Performance Dashboard",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Post Occupancy Monitoring",
    basePrice: 7750,
    price: 7750,
    description: "Real-time performance dashboards for monitoring federal building systems and operational efficiency.",
    capturedDate: "2024-02-05",
    contentType: "Private"
  },
  {
    id: "gsa-pom4",
    title: "Occupant Comfort & Building Performance Feedback",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Post Occupancy Monitoring",
    basePrice: 6750,
    price: 6750,
    description: "Tools for collecting and analyzing occupant comfort data and building performance feedback in federal facilities.",
    capturedDate: "2024-01-22",
    contentType: "Public"
  },
  {
    id: "gsa-pom5",
    title: "Continuous Improvement Implementation Strategies",
    agency: "GSA",
    curator: "Julia De Rosi",
    commercialType: "Sale",
    category: "Post Occupancy Monitoring",
    basePrice: 7000,
    price: 7000,
    description: "Strategic frameworks for implementing continuous improvement processes in federal building operations.",
    capturedDate: "2024-02-12",
    contentType: "Private"
  },
  // Quebec Solutions
  {
    id: "qc-001",
    title: "Clean Energy Export Strategy – Quebec to Texas",
    agency: "Quebec",
    curator: "Eglantine Pauvarel Moss",
    commercialType: "Sale",
    category: "Energy",
    basePrice: 9500,
    price: 9500,
    description: "Comprehensive strategy for Quebec hydroelectric power exports to Texas markets with implementation roadmap.",
    capturedDate: "2024-06-15",
    contentType: "Private"
  },
  {
    id: "qc-002",
    title: "Maritime Logistics Digital Transformation Framework",
    agency: "Quebec",
    curator: "Eglantine Pauvarel Moss",
    commercialType: "Sale",
    category: "Maritime",
    basePrice: 8200,
    price: 8200,
    description: "Digital transformation framework for St. Lawrence Seaway logistics optimization and port efficiency.",
    capturedDate: "2024-05-28",
    contentType: "Private"
  },
  {
    id: "qc-003",
    title: "Critical Minerals Supply Chain Security Plan",
    agency: "Quebec",
    curator: "Steven Jast",
    commercialType: "Collaborate",
    category: "Mining",
    basePrice: 12500,
    price: 2500,
    description: "Strategic plan for securing critical minerals supply chains between Quebec and US manufacturing partners.",
    capturedDate: "2024-06-02",
    contentType: "Private"
  },
  {
    id: "qc-004",
    title: "Quebec-US EV Manufacturing Integration Strategy",
    agency: "Quebec",
    curator: "Steven Jast",
    commercialType: "Sale",
    category: "Automotive",
    basePrice: 10800,
    price: 10800,
    description: "Strategic framework for integrating Quebec's EV battery manufacturing into US automotive supply chains.",
    capturedDate: "2024-05-10",
    contentType: "Private"
  },
  {
    id: "qc-005",
    title: "Sustainable Aerospace Materials Innovation Network",
    agency: "Quebec",
    curator: "Eglantine Pauvarel Moss",
    commercialType: "Stake",
    category: "Aerospace",
    basePrice: 13500,
    price: 6750,
    description: "Knowledge network connecting Quebec aerospace materials innovation with US defense and commercial aerospace sectors.",
    capturedDate: "2024-04-18",
    contentType: "Public"
  },
  {
    id: "qc-006",
    title: "Cross-Border AI Research Commercialization Framework",
    agency: "Quebec",
    curator: "Steven Jast",
    commercialType: "Lease",
    category: "Technology",
    basePrice: 15000,
    price: 1500,
    description: "Framework for commercializing Quebec AI research innovations in US markets with implementation roadmap.",
    capturedDate: "2024-05-22",
    contentType: "Private"
  },
  {
    id: "qc-007",
    title: "Port of Montreal-Gulf Coast Maritime Partnership Model",
    agency: "Quebec",
    curator: "Eglantine Pauvarel Moss",
    commercialType: "Sale",
    category: "Maritime",
    basePrice: 7500,
    price: 7500,
    description: "Strategic partnership model connecting Port of Montreal with Gulf Coast ports for optimized North American shipping.",
    capturedDate: "2024-06-08",
    contentType: "Public"
  },
  {
    id: "qc-008",
    title: "Circular Economy in Resource Development",
    agency: "Quebec",
    curator: "Ozlem Tuncel Toplu",
    commercialType: "Sale",
    category: "Sustainability",
    basePrice: 8900,
    price: 8900,
    description: "Implementation framework for circular economy practices in resource extraction and processing industries.",
    capturedDate: "2024-05-15",
    contentType: "Public"
  },
  {
    id: "qc-009",
    title: "Economic Corridor Investment Attraction Strategy",
    agency: "Quebec",
    curator: "Ozlem Tuncel Toplu",
    commercialType: "Collaborate",
    category: "Economic Development",
    basePrice: 11200,
    price: 2240,
    description: "Comprehensive strategy for attracting investment along key economic corridors between Canada and the US.",
    capturedDate: "2024-06-01",
    contentType: "Private"
  },
  {
    id: "qc-010",
    title: "Cross-Border Energy Infrastructure Security Framework",
    agency: "Quebec",
    curator: "Ozlem Tuncel Toplu",
    commercialType: "Sale",
    category: "Energy",
    basePrice: 9600,
    price: 9600,
    description: "Security framework for protecting critical energy infrastructure spanning the Canada-US border.",
    capturedDate: "2024-05-18",
    contentType: "Private"
  }
];